import React from 'react';
import { Card } from 'react-bootstrap';
export default function DashCardBlue(_ref) {
  let {
    titleIcon,
    title,
    body,
    fullHeight = true
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    className: "bg-primary2 dashboard-card-blue ".concat(fullHeight ? 'h-100' : '')
  }, /*#__PURE__*/React.createElement(Card.Body, {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, titleIcon && /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      width: '40px',
      height: '40px'
    }
  }, titleIcon), /*#__PURE__*/React.createElement("h4", {
    className: "dashboard-card-title dashboard-card-title-small ".concat(!!titleIcon ? 'ms-3' : '')
  }, title)), body));
}